// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* --- THEMES --- */

:root[theme="light"] {
    --bg: #fff;
    --white: #fff;
    --font-dark: #15304f;
    --font-light: #858896;
    --border: #dddddd;
    --secondary: #e9e9e9;
    --secondary-dark: #d6d6d6;
    --lighter-2: #a2a9b6;
    --dark: #272B2C;
    --light: #ddd;
    --lighter: #eee;
    --accent-1: #2a2a2a;
    --accent-2: #2f2f2f;
    --passed: #44AB3F;
    --failed: #D54A4A;
    --warn: #FFBE37;
}

:root[theme="dark"] {
    --bg: #333;
    --white: #222425;
    --font-dark: #b3b1ab;
    --font-light: #979086;
    --border: #373b3c;
    --secondary: #2d3032;
    --secondary-dark: #373b3c;
    --lighter-2: #2b2d2f;
    --dark: #eee;
    --light: #555;
    --lighter: #444;
    --accent-1: #efefef;
    --accent-2: #eee;
    --passed: #44AB3F;
    --failed: #D54A4A;
    --warn: #FFBE37;
}

.flex-display{
    display: flex;
}

@media only screen and (max-width: 820px) {
    .headerLogo {
        height: 3.5rem;
    }

    header.SecondaryTheme.toolbar {
        z-index: 10;
    }

    .SecondaryTheme .language-selector.logged-in .dropdown .btn-secondary {
        min-width: 150px;
    }

    .centered-layout .settings {
        display: flex;
        justify-content: space-around;
    }

    .centered-layout .settings .form {
        flex-grow: 1;
        padding-left: 20px;
    }

    .my-settings .label-warning {
        display: flex;
        flex-direction: column;
    }

    .table-responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .course-box-list {
        justify-content: center;
    }

    .courses-toolbar {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 5px 10px;
    }

    .courses-toolbar button {
        margin: 0px !important;
    }

    .courses-toolbar-item div,
    .courses-toolbar-item div>button {
        width: 100%;
    }

    .courses-toolbar-item {
        flex-grow: 1;
        max-width: 100%;
    }

    .search-courses {
        max-width: 100%;
    }

    header.toolbar {
        height: 138px !important;
    }

    .toolbar-section {
        display: inline-grid;
        flex-direction: row;
        align-items: center;
    }

    header .toolbar-section:last-child {
        justify-content: center;
    }

    .SecondaryTheme .hero-img {
        background: var(--accent-1);
        width: auto;
        height: 292px;
        position: inherit;
        top: unset;
        right: unset;
        flex-grow: 1;
    }

    .SecondaryTheme .hero-content {
        padding: 0;
        position: initial;
        z-index: auto;
        max-width: none;
        min-width: min-content;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        justify-content: center;
    }

    .SecondaryTheme .hero {
        flex-direction: row;
        padding: 0 ;
    }

    /* START - Course overview page */
    .course-page-header .hero {
        justify-content: center;
    }

    .SecondaryTheme .course-page-header,
    .SecondaryTheme .course-page-content {
        padding: 2.5%;
    }

    .SecondaryTheme .course-page-header .hero-content {
        padding: 0;
    }

    .course-page-content .flex-row {
        flex-wrap: wrap-reverse;
        row-gap: 20px;
    }

    .course-content-section .big-number-list .padding {
        flex-wrap: wrap;
        row-gap: 10px;
    }

    .course-content-section .upload-input {
        max-width: 200px;
    }
    /* END - Course overview page */

    #PdfViewer .box-header {
        justify-content: space-around;
        row-gap: 10px;
    }

    #PdfViewer .item {
        width: auto;
        padding: 0px 5px;
    }

    #PdfViewer .box-controls {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        flex-grow: 1;
        column-gap: 5px;
    }

    #PdfViewer .box-controls .ml-2 {
        margin-left: 0px !important;
    }

    #PdfViewer .box-controls-footer {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex-grow: 1; /* Set the middle element to grow and stretch */

        /*display: flex;*/
        /*flex-direction: row;*/
        /*justify-content: space-around;*/
        /*flex-grow: 1;*/
        /*column-gap: 5px;*/
    }

    #PdfViewer .box-controls-footer .ml-2 {
        margin-left: 0px !important;
    }

    #PdfViewer .acknowledge-panel {
        flex-wrap: wrap;
        gap: 0.8rem;
        padding: 0.8rem 1rem;
    }

    #PdfViewer .acknowledge-panel-icon {
        display: none;
    }

    #PdfViewer .acknowledge-panel-statement {
        font-size: 1rem;
    }

    #PdfViewer .acknowledge-panel-save {
        width: 100%;
    }

    .toolbar-section > *:not(:last-child) {
        margin-right: 0.04rem !important;
    }

    header.toolbar {
        position: relative;
        padding: 0.5rem 1%!important;
    }

    .language-selector.logged-in {
        position: inherit;
        line-height: 30px;
        max-height: 30px;
        top: 55px;
        width:auto;
    }

    .language-selector.public {
        display: inline-flex;
        justify-content: end;
        position: relative;
        top: 40px;
        left: 0px;
    }

    .language-selector.logged-in .btn {
        display: none;
    }

    .language-selector.logged-in:hover .btn {
        display: flex;
    }

    .language-selector.logged-in .toolbar-title {
        display: block;
    }

    .public .dropdown-list{
        left: -100px!important;
    }

    .lang-selector {
        max-height: 77vh;
    }

    .toolbar-section.logged-in>*:not(:last-child) {
        margin-right: 0rem;
    }

    .toolbar-title {
        text-align: -webkit-right;
    }

    .toolbar-title>i.icon-back.hidden {
        display: inline-block;
        position: relative;
        top: 6px;
    }

    /*login-page START*/

    #auth-right{
        display: none;
    }
    /*login-page    end*/
    .SubNavBar__width {
        display: flex;
        flex-direction: row;
    }

    .SubNavBar__navItem, .SubNavBar__navItem-selected {
        justify-content: center;
        flex: 50%;
    }

    .SubNavBar_text {
        display: none;
    }

    .m-tooltip {
        position: relative;
    }

    .m-tooltip:hover::after {
        opacity: 1;
        transform: translate(-50%, -.2rem);
    }

    .m-tooltip::after {
        font-family: sans-serif;
        background: var(--dark);
        border-radius: .1rem;
        top: 110%;
        color: var(--lighter);
        content: attr(m-data-tooltip);
        display: block;
        font-size: .7rem;
        left: 50%;
        max-width: 320px;
        opacity: 0;
        overflow: hidden;
        padding: .2rem .4rem;
        pointer-events: none;
        position: absolute;
        text-overflow: ellipsis;
        transform: translate(-50%, .4rem);
        transition: opacity .2s, transform .2s;
        white-space: pre;
        z-index: 300;
    }

    .m-tooltip-left {
        position: relative;
    }

    .m-tooltip-left:hover::after {
        opacity: 1;
        transform: translate(-50%, -.2rem);
    }

    .m-tooltip-left::after {
        font-family: sans-serif;
        background: var(--dark);
        border-radius: .1rem;
        top: 90%;
        color: var(--lighter);
        content: attr(m-data-tooltip);
        display: block;
        font-size: .7rem;
        left: -50%;
        max-width: 320px;
        opacity: 0;
        overflow: hidden;
        padding: .2rem .4rem;
        pointer-events: none;
        position: absolute;
        text-overflow: ellipsis;
        transform: translate(-50%, .4rem);
        transition: opacity .2s, transform .2s;
        white-space: pre;
        z-index: 300;
    }

    .profile-icon{
        display: block;
        width: 40px;
        position: relative;
        padding-right: 10px;
        padding-bottom: 10px;
    }

    .hide-text {
        display: none !important;
    }

    .show-icon .icon{
        width: 20px !important;
        display: block !important;
    }

    .show-icon .btn-text, .show-icon i{
        display: none !important;
    }

    .grecaptcha-badge { 
        visibility: hidden;
    }

    .grecaptcha-badge-replacement { 
        visibility: initial;
        color: var(--font-light);
        max-width: 300px;
        padding-top: 5px;
        align-self: center;
    }

    #auth-left {
        min-width: 250px;
    }

    #toaster > .toast .toast-message {
        white-space: unset !important;
    }
}

@media only screen and (max-width: 600px) {
    /* Phone width: let modals use the screen instead of a fixed desktop width.
       #modal-inner already scrolls (overflow-y: auto), so long content isn't cut off. */
    .modal #modal-inner {
        max-width: calc(100% - 1.5rem);
        min-width: 0;
        max-height: calc(100% - 2rem);
        margin-top: 1rem;
        padding: 1.2rem;
        box-sizing: border-box;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive-styles.css"],"names":[],"mappings":";AACA,mBAAmB;;AAEnB;IACI,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,eAAe;QACf,8BAA8B;QAC9B,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;QAC3B,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB,UAAU;QACV,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,sBAAsB;QACtB,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA,iCAAiC;IACjC;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;IACA,+BAA+B;;IAE/B;QACI,6BAA6B;QAC7B,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,6BAA6B;QAC7B,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,YAAY,EAAE,+CAA+C;;QAE7D,iBAAiB;QACjB,uBAAuB;QACvB,iCAAiC;QACjC,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,kBAAkB;QAClB,SAAS;QACT,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA,mBAAmB;;IAEnB;QACI,aAAa;IACjB;IACA,oBAAoB;IACpB;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kCAAkC;IACtC;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,oBAAoB;QACpB,SAAS;QACT,qBAAqB;QACrB,6BAA6B;QAC7B,cAAc;QACd,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,gBAAgB;QAChB,oBAAoB;QACpB,oBAAoB;QACpB,kBAAkB;QAClB,uBAAuB;QACvB,iCAAiC;QACjC,sCAAsC;QACtC,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kCAAkC;IACtC;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,oBAAoB;QACpB,QAAQ;QACR,qBAAqB;QACrB,6BAA6B;QAC7B,cAAc;QACd,gBAAgB;QAChB,UAAU;QACV,gBAAgB;QAChB,UAAU;QACV,gBAAgB;QAChB,oBAAoB;QACpB,oBAAoB;QACpB,kBAAkB;QAClB,uBAAuB;QACvB,iCAAiC;QACjC,sCAAsC;QACtC,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;wFACoF;IACpF;QACI,8BAA8B;QAC9B,YAAY;QACZ,6BAA6B;QAC7B,gBAAgB;QAChB,eAAe;QACf,sBAAsB;IAC1B;AACJ","sourcesContent":["\n/* --- THEMES --- */\n\n:root[theme=\"light\"] {\n    --bg: #fff;\n    --white: #fff;\n    --font-dark: #15304f;\n    --font-light: #858896;\n    --border: #dddddd;\n    --secondary: #e9e9e9;\n    --secondary-dark: #d6d6d6;\n    --lighter-2: #a2a9b6;\n    --dark: #272B2C;\n    --light: #ddd;\n    --lighter: #eee;\n    --accent-1: #2a2a2a;\n    --accent-2: #2f2f2f;\n    --passed: #44AB3F;\n    --failed: #D54A4A;\n    --warn: #FFBE37;\n}\n\n:root[theme=\"dark\"] {\n    --bg: #333;\n    --white: #222425;\n    --font-dark: #b3b1ab;\n    --font-light: #979086;\n    --border: #373b3c;\n    --secondary: #2d3032;\n    --secondary-dark: #373b3c;\n    --lighter-2: #2b2d2f;\n    --dark: #eee;\n    --light: #555;\n    --lighter: #444;\n    --accent-1: #efefef;\n    --accent-2: #eee;\n    --passed: #44AB3F;\n    --failed: #D54A4A;\n    --warn: #FFBE37;\n}\n\n.flex-display{\n    display: flex;\n}\n\n@media only screen and (max-width: 820px) {\n    .headerLogo {\n        height: 3.5rem;\n    }\n\n    header.SecondaryTheme.toolbar {\n        z-index: 10;\n    }\n\n    .SecondaryTheme .language-selector.logged-in .dropdown .btn-secondary {\n        min-width: 150px;\n    }\n\n    .centered-layout .settings {\n        display: flex;\n        justify-content: space-around;\n    }\n\n    .centered-layout .settings .form {\n        flex-grow: 1;\n        padding-left: 20px;\n    }\n\n    .my-settings .label-warning {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .table-responsive {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .course-box-list {\n        justify-content: center;\n    }\n\n    .courses-toolbar {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        gap: 5px 10px;\n    }\n\n    .courses-toolbar button {\n        margin: 0px !important;\n    }\n\n    .courses-toolbar-item div,\n    .courses-toolbar-item div>button {\n        width: 100%;\n    }\n\n    .courses-toolbar-item {\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .search-courses {\n        max-width: 100%;\n    }\n\n    header.toolbar {\n        height: 138px !important;\n    }\n\n    .toolbar-section {\n        display: inline-grid;\n        flex-direction: row;\n        align-items: center;\n    }\n\n    header .toolbar-section:last-child {\n        justify-content: center;\n    }\n\n    .SecondaryTheme .hero-img {\n        background: var(--accent-1);\n        width: auto;\n        height: 292px;\n        position: inherit;\n        top: unset;\n        right: unset;\n        flex-grow: 1;\n    }\n\n    .SecondaryTheme .hero-content {\n        padding: 0;\n        position: initial;\n        z-index: auto;\n        max-width: none;\n        min-width: min-content;\n        width: 50%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        justify-content: center;\n    }\n\n    .SecondaryTheme .hero {\n        flex-direction: row;\n        padding: 0 ;\n    }\n\n    /* START - Course overview page */\n    .course-page-header .hero {\n        justify-content: center;\n    }\n\n    .SecondaryTheme .course-page-header,\n    .SecondaryTheme .course-page-content {\n        padding: 2.5%;\n    }\n\n    .SecondaryTheme .course-page-header .hero-content {\n        padding: 0;\n    }\n\n    .course-page-content .flex-row {\n        flex-wrap: wrap-reverse;\n        row-gap: 20px;\n    }\n\n    .course-content-section .big-number-list .padding {\n        flex-wrap: wrap;\n        row-gap: 10px;\n    }\n\n    .course-content-section .upload-input {\n        max-width: 200px;\n    }\n    /* END - Course overview page */\n\n    #PdfViewer .box-header {\n        justify-content: space-around;\n        row-gap: 10px;\n    }\n\n    #PdfViewer .item {\n        width: auto;\n        padding: 0px 5px;\n    }\n\n    #PdfViewer .box-controls {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        flex-grow: 1;\n        column-gap: 5px;\n    }\n\n    #PdfViewer .box-controls .ml-2 {\n        margin-left: 0px !important;\n    }\n\n    #PdfViewer .box-controls-footer {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n        flex-grow: 1; /* Set the middle element to grow and stretch */\n\n        /*display: flex;*/\n        /*flex-direction: row;*/\n        /*justify-content: space-around;*/\n        /*flex-grow: 1;*/\n        /*column-gap: 5px;*/\n    }\n\n    #PdfViewer .box-controls-footer .ml-2 {\n        margin-left: 0px !important;\n    }\n\n    #PdfViewer .acknowledge-panel {\n        flex-wrap: wrap;\n        gap: 0.8rem;\n        padding: 0.8rem 1rem;\n    }\n\n    #PdfViewer .acknowledge-panel-icon {\n        display: none;\n    }\n\n    #PdfViewer .acknowledge-panel-statement {\n        font-size: 1rem;\n    }\n\n    #PdfViewer .acknowledge-panel-save {\n        width: 100%;\n    }\n\n    .toolbar-section > *:not(:last-child) {\n        margin-right: 0.04rem !important;\n    }\n\n    header.toolbar {\n        position: relative;\n        padding: 0.5rem 1%!important;\n    }\n\n    .language-selector.logged-in {\n        position: inherit;\n        line-height: 30px;\n        max-height: 30px;\n        top: 55px;\n        width:auto;\n    }\n\n    .language-selector.public {\n        display: inline-flex;\n        justify-content: end;\n        position: relative;\n        top: 40px;\n        left: 0px;\n    }\n\n    .language-selector.logged-in .btn {\n        display: none;\n    }\n\n    .language-selector.logged-in:hover .btn {\n        display: flex;\n    }\n\n    .language-selector.logged-in .toolbar-title {\n        display: block;\n    }\n\n    .public .dropdown-list{\n        left: -100px!important;\n    }\n\n    .lang-selector {\n        max-height: 77vh;\n    }\n\n    .toolbar-section.logged-in>*:not(:last-child) {\n        margin-right: 0rem;\n    }\n\n    .toolbar-title {\n        text-align: -webkit-right;\n    }\n\n    .toolbar-title>i.icon-back.hidden {\n        display: inline-block;\n        position: relative;\n        top: 6px;\n    }\n\n    /*login-page START*/\n\n    #auth-right{\n        display: none;\n    }\n    /*login-page    end*/\n    .SubNavBar__width {\n        display: flex;\n        flex-direction: row;\n    }\n\n    .SubNavBar__navItem, .SubNavBar__navItem-selected {\n        justify-content: center;\n        flex: 50%;\n    }\n\n    .SubNavBar_text {\n        display: none;\n    }\n\n    .m-tooltip {\n        position: relative;\n    }\n\n    .m-tooltip:hover::after {\n        opacity: 1;\n        transform: translate(-50%, -.2rem);\n    }\n\n    .m-tooltip::after {\n        font-family: sans-serif;\n        background: var(--dark);\n        border-radius: .1rem;\n        top: 110%;\n        color: var(--lighter);\n        content: attr(m-data-tooltip);\n        display: block;\n        font-size: .7rem;\n        left: 50%;\n        max-width: 320px;\n        opacity: 0;\n        overflow: hidden;\n        padding: .2rem .4rem;\n        pointer-events: none;\n        position: absolute;\n        text-overflow: ellipsis;\n        transform: translate(-50%, .4rem);\n        transition: opacity .2s, transform .2s;\n        white-space: pre;\n        z-index: 300;\n    }\n\n    .m-tooltip-left {\n        position: relative;\n    }\n\n    .m-tooltip-left:hover::after {\n        opacity: 1;\n        transform: translate(-50%, -.2rem);\n    }\n\n    .m-tooltip-left::after {\n        font-family: sans-serif;\n        background: var(--dark);\n        border-radius: .1rem;\n        top: 90%;\n        color: var(--lighter);\n        content: attr(m-data-tooltip);\n        display: block;\n        font-size: .7rem;\n        left: -50%;\n        max-width: 320px;\n        opacity: 0;\n        overflow: hidden;\n        padding: .2rem .4rem;\n        pointer-events: none;\n        position: absolute;\n        text-overflow: ellipsis;\n        transform: translate(-50%, .4rem);\n        transition: opacity .2s, transform .2s;\n        white-space: pre;\n        z-index: 300;\n    }\n\n    .profile-icon{\n        display: block;\n        width: 40px;\n        position: relative;\n        padding-right: 10px;\n        padding-bottom: 10px;\n    }\n\n    .hide-text {\n        display: none !important;\n    }\n\n    .show-icon .icon{\n        width: 20px !important;\n        display: block !important;\n    }\n\n    .show-icon .btn-text, .show-icon i{\n        display: none !important;\n    }\n\n    .grecaptcha-badge { \n        visibility: hidden;\n    }\n\n    .grecaptcha-badge-replacement { \n        visibility: initial;\n        color: var(--font-light);\n        max-width: 300px;\n        padding-top: 5px;\n        align-self: center;\n    }\n\n    #auth-left {\n        min-width: 250px;\n    }\n\n    #toaster > .toast .toast-message {\n        white-space: unset !important;\n    }\n}\n\n@media only screen and (max-width: 600px) {\n    /* Phone width: let modals use the screen instead of a fixed desktop width.\n       #modal-inner already scrolls (overflow-y: auto), so long content isn't cut off. */\n    .modal #modal-inner {\n        max-width: calc(100% - 1.5rem);\n        min-width: 0;\n        max-height: calc(100% - 2rem);\n        margin-top: 1rem;\n        padding: 1.2rem;\n        box-sizing: border-box;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
